<template>
    <div :class="$vuetify.breakpoint.smAndUp ? 'px-12 mt-6' : 'mx-2'">
        <div :class="$vuetify.breakpoint.smAndUp ? 'px-2 mx-12 mb-2' : 'px-2 mx-5 mb-2'">
            <v-row dense>
                <v-col md="10" cols="12" v-if="hasAdminPermission">
                    <v-autocomplete 
                        class="pa-4"
                        :items="comerciales" 
                        v-model="account" 
                        item-text="nombreCompleto"
                        item-value="id" 
                        prepend-icon="mdi-account"
                        persistent-hint 
                        :hint="account ? 'Elimine los filtros para ver todos' : 'Seleccione para filtrar'"
                        label="Todos los empleados" 
                        clearable
                        @change="search()"
                        :disabled="!comerciales || comerciales.length == 0 || userPaysheetsIsLoading || userContractsIsLoading"
                        :loading="!comerciales || comerciales.length == 0 || userPaysheetsIsLoading || userContractsIsLoading"
                    >
                    </v-autocomplete>
                </v-col>
                <v-col :md="hasAdminPermission ? '2' :'12'" cols="12" class="d-flex flex-row align-self-center justify-center">
                    <v-btn-toggle v-model="toggle_exclusive" color="primary" mandatory>
                        <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    depressed
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="userPaysheetsIsLoading || userContractsIsLoading"
                                >
                                    <div>
                                        <p class="mb-n1">Filtrar</p>
                                        <small class="mt-n1">{{date}}</small>
                                    </div>
                                    <v-icon right>mdi-calendar</v-icon>
                                </v-btn>
                            </template>
                            <v-date-picker
                                v-model="date"
                                type="month"
                                @input="menu2 = false"
                                :disabled="userPaysheetsIsLoading || userContractsIsLoading"
                            ></v-date-picker>
                        </v-menu>
                        <v-btn 
                            @click="date=null" 
                            depressed
                            color="selectedDateFilter == 1 ? 'primary' : ''"
                        >
                            Todo
                            <v-icon right>mdi-expand-all</v-icon>
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
        </div>
        <v-row :class="$vuetify.breakpoint.smAndUp ? 'px-12' : 'mx-2'">
            <v-col cols="12" md="12">
                <v-card elevation="0" :loading="userImagesIsLoading">
                    <v-card-title class="d-flex justify-space-around">
                        <v-icon color="" large>mdi-image-outline</v-icon>
                        <h2 class="font-weight-light primary--text">Imágenes</h2>
                        <v-icon color="" large>mdi-folder-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-btn 
                            block
                            depressed
                            @click="showImages = !showImages"
                            v-if="hasAdminPermission"
                        >
                            <v-icon left v-if="showImages">mdi-eye-outline</v-icon>
                            <v-icon left v-else>mdi-eye-off-outline</v-icon>
                            {{ showImages ? 'Ocultar' : 'Mostrar' }}
                            <v-icon right v-if="showImages">mdi-arrow-down</v-icon>
                            <v-icon right v-else>mdi-arrow-up</v-icon>
                        </v-btn>
                        <v-expand-transition>
                            <StorageImages v-show="showImages || !hasAdminPermission"/>
                        </v-expand-transition>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card elevation="0" :loading="userContractsIsLoading">
                    <v-card-title class="d-flex justify-space-around">
                        <v-icon color="" large>mdi-file-sign</v-icon>
                        <h2 class="font-weight-light primary--text">Documentos</h2>
                        <v-icon color="" large>mdi-folder-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <StorageContracts/>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card elevation="0" :loading="userPaysheetsIsLoading">
                    <v-card-title class="d-flex justify-space-around">
                        <v-icon color="" large>mdi-account-credit-card-outline</v-icon>
                        <h2 class="font-weight-light primary--text">Nóminas</h2>
                        <v-icon color="" large>mdi-folder-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <StoragePaysheets/>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

		<div
			class="d-flex flex-rows"
			style="position: fixed; right: 10px; bottom: 20px"
		>
            <v-btn
                fab
                color="pink"
                dark
                x-large
                class="mx-1"
                @click="openContractForm()"
                v-if="hasAdminPermission"
            >
                <v-icon>mdi-file-sign</v-icon>
            </v-btn>
            <v-btn
                fab
                color="deep-purple"
                dark
                x-large
                class="mx-1"
                @click="openPaysheetForm()"
                v-if="hasAdminPermission"
            >
                <v-icon>mdi-account-credit-card-outline</v-icon>
            </v-btn>
        </div>

        <ContractForm/>
        <PaysheetForm/>
        <DeleteDialog/>
    </div>
</template>

<script>
import StorageImages from './StorageImages.vue';
import StoragePaysheets from './StoragePaysheets.vue';
import StorageContracts from './StorageContracts.vue';

import ContractForm from './ContractForm.vue';
import PaysheetForm from './PaysheetForm.vue';
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';

import { mapState, mapGetters } from 'vuex';

export default {
    data: ()=> ({
        toggle_exclusive: 0,
        showImages: false,
        menu2: false,
    }),
    components: {
        StorageImages,
        StoragePaysheets,
        StorageContracts,
        ContractForm,
        PaysheetForm,
        DeleteDialog,
    },
    computed: {
        account: {
            get() {
                return this.$store.state.storage.filters.account;
            },
            set(value) {
                this.$store.commit('storage/accountFilter', value);
            },
        },
        date: {
            get() {
                return this.$store.state.storage.filters.month;
            },
            set(value) {
                this.$store.commit('storage/monthFilter', value);
            },
        },
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
		}),
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales.filter((comercial) => comercial.nombreCompleto != 'Por asignar'),
        }),
        ...mapState('storage', {
            userImagesIsLoading: (state) => state.userImages.isLoading,
            userPaysheetsIsLoading: (state) => state.userPaysheets.isLoading,
            userContractsIsLoading: (state) => state.userContracts.isLoading,
        }),
    },
    methods: {
        initialise() {
            if (this.$store.state.storage.userImages.images.length === 0) {
                this.$store.dispatch('storage/getUserImages');
            }
            if (this.$store.state.storage.userPaysheets.paysheets.length === 0) {
                this.$store.dispatch('storage/getUserPaysheet');
            }
            if (this.$store.state.storage.userContracts.contracts.length === 0) {
                this.$store.dispatch('storage/getUserContracts');
            }
            if (this.$store.state.teletrabajo.Comerciales.length === 0) {
                this.$store.dispatch('teletrabajo/fetchComerciales');
            }
        },
        search() {
            this.$store.dispatch('storage/fetchAll', {});
        },
        getUserPaySheets() {
            this.$store.dispatch('storage/getUserPaysheet');
        },
        openContractForm() {
            this.$store.commit('storage/userContractsIsOpen', true);
        },
        openPaysheetForm() {
            this.$store.commit('storage/userPaysheetsIsOpen', true);
        },
    },
    mounted() {
        this.initialise();
    },
    watch: {
        toggle_exclusive(val){
            if (val === 1){
                this.date = null
            }
        },
        menu2(val){
            if (!val && !this.date){
                this.toggle_exclusive = 1
            }
        },
        date(){
            this.getUserPaySheets()
        }
    }
}
</script>